import { Model } from "pinia-orm";
import { CertificationProject, DomainVersion, Step } from "@/models";
import { convertRelativeDeltaField } from "@/utils/convertRelativeDeltaField";

export default class Cycle extends Model {
  static entity = "cycles";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
      code: this.string(""),
      order: this.attr(1),
      cycleType: this.string(""),
      area: this.string(""),
      endApplication: this.string("P0Y0M0D"),
      price: this.attr(0),
      cycleOption: this.attr(null),
      contractDocumentUuid: this.string(""),
      maxEndDate: this.string(null),
      hasManualCertifiedDate: this.boolean(false),

      // Foreign keys
      domainVersionUuid: this.string(""),
      certificationProjectsList: this.hasMany(CertificationProject, "cycleUuid"),
      domainVersionData: this.belongsTo(DomainVersion, "domainVersionUuid"),
      stepsList: this.hasMany(Step, "cycleUuid"),
      isDisplayed: this.boolean(true),
      createdAt: this.string(""),
    };
  }

  get duration() {
    return convertRelativeDeltaField(this.endApplication).months;
  }
}
